import { AxDropdown } from "@axess/limestone";
import Swal from "sweetalert2";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { CompPackBookingValues } from "../../Models/ComplexPackages/BookingOptions/CompPackBookingValues";
import { AxPixelTracking } from "../AxMetaTracking/AxPixelTracking";
import { CompPackBookingPersonOptions } from "./BookingOptions/CompPackBookingPersonOptions";
import { ComplexPackageBookingTicketsOptions } from "./BookingOptions/ComplexPackageBookingTicketsOptions";

@ModuleName("ComplexPackageBookingOptions")
export class ComplexPackageBookingOptions implements AxInit {
    public dropDowns = new Array<AxDropdown>();
    public bookingValuesList: CompPackBookingValues[] = [];
    public participants: string[] = [];
    public initData: initData = {} as initData;

    private $parent: JQuery<HTMLElement> = $('[data-frontoffice-view="complexpackagesbooking"]');
    private axLoading: AxLoading = {} as AxLoading;
    private i18NHelper: I18nHelper = {} as I18nHelper;
    private shoppingCartUrl: string = '';

    AxInit(init: initData): void {
        this.axLoading = new AxLoading();
        this.i18NHelper = new I18nHelper();
        this.shoppingCartUrl = init.shoppingCartUrl;
        this.initData = init;
        this.participants = [...Array(this.initData.participants)];

        // object for addToCart
        this.participants.forEach(() => {
            this.bookingValuesList.push(new CompPackBookingValues(init.projNr, init.packageId, init.tariffSheetId, init.startSoapDate, init.endSoapDate))
        });
        $('#compPackAddToCartBtn').on('click', () => this.addToCart());

        this.$parent.on('click', '.compPack_products_item_card_header', (e: JQuery.ClickEvent<HTMLElement>) => {
            const $current = $(e.currentTarget);
            const $parent = $current.closest('div.participant');
            const $siblings = $parent.siblings('.participant')
            const $arrow = $current.find('i');
            let $next = $parent.nextAll('.participant').first();
            if (!$next.length) {
                $next = $parent.siblings('.participant').first();
            }
            if ($parent.hasClass('expanded')) {
                $parent.removeClass('expanded');
                $arrow.removeClass('la-angle-up').addClass('la-angle-down');
                $next.addClass('expanded');
                $next.find('i').removeClass('la-angle-down').addClass('la-angle-up');
            } else {
                $parent.addClass('expanded');
                $arrow.removeClass('la-angle-down').addClass('la-angle-up');
                $siblings.removeClass('expanded');
                $siblings.find('i').removeClass('la-angle-up').addClass('la-angle-down');
            }
        });
    }

    getControlBySelector(selector: string): AxDropdown | JQuery<HTMLElement> | undefined {
        const $control = $(selector);
        const $input = $(selector.replace('.ax-dropdown', 'input'));
        const isInput = $input.length > 0;
        if ($control.length > 0) {
            return this.dropDowns.find((i) => i.getSelector() === selector);
        } else if (isInput) {
            return $input;
        }
    }

    validateInputs() {
        let valid: boolean = true;
        this.bookingValuesList.forEach((bookingValues, i) => {
            const participant = i + 1;
            const bookingModule = AxLoad.GetModule<ComplexPackageBookingTicketsOptions>("ComplexPackageBookingTicketsOptions");
            const $lessonOptionHolder = this.$parent.find('#lessonOptionsHolder');
            const hasTimeSlotLesson = this.$parent.find('#lessonOptionsHolder').children().length > 0 && $('.prod_selection__lesson-selection').length > 0;
            const isRentalOptionsHolder = this.$parent.find('[data-rental-holder]').length > 0;
            const $skillLevelPillHolder = this.$parent.find('.compPack_User_SkillLevel_pillHolder button');
            const $personOptionsHolder = this.$parent.find(`#personOptionsHolder-${participant}`);
            const lessonProgramDropdown = this.getControlBySelector(`.prod_selection__lessonProgramSlot-selection .ax-dropdown`);
            const personDropdown = this.getControlBySelector(`.prod_selection__person-selection.participant-${participant} .ax-dropdown`);
            const genderDropdown = this.getControlBySelector(`.prod_selection__gender-selection.participant-${participant} .ax-dropdown`);
            const heightDropdown = this.getControlBySelector(`.prod_selection__height-selection.participant-${participant} .ax-dropdown`);
            const weightDropdown = this.getControlBySelector(`.prod_selection__weight-selection.participant-${participant} .ax-dropdown`);
            const shoeSizeDropdown = this.getControlBySelector(`.prod_selection__shoeSize-selection.participant-${participant} .ax-dropdown`);

            // person select
            if (!personDropdown || !personDropdown.val()) {
                valid = false;
                const $card = $('.compPack_products_item_card.participant');
                $card.addClass('expanded');
                $card.find('i').removeClass('la-angle-down').addClass('la-angle-up');
                $personOptionsHolder.removeClass('d-none');
            } else {
                $personOptionsHolder.addClass('d-none');
            }

            // Timeslots ticket
            bookingValues?.ticketOrderValues?.forEach((ticket) => {
                const elementName = `#compPack_products_ticket_holder_${ticket.projNr}_${ticket.poolNr}_${ticket.ticketTypeNr}`;
                const $element = $(elementName);
                
                if (ticket.hasTimeSlots) {
                    const validTimeSlots = bookingModule.CheckTimeSlotPackagePos(ticket?.packagePositionNr);
                    if (!validTimeSlots) {
                        $element.addClass('invalid-form');
                        valid = false;
                        return this.jumpToSelector(elementName);
                    } else {
                        $element.removeClass('invalid-form');
                    }
                }
            });

            if ($lessonOptionHolder.length > 0 && lessonProgramDropdown && bookingValues.lessonProgramOrderValues?.length == 0) {
                valid = false;
                this.jumpToSelector('.prod_selection__lessonProgramSlot-selection .ax-dropdown');
            }

            if ($('[data-cp-lessons="out"]').length > 0) {
                valid = false;
            }
            
            if (hasTimeSlotLesson) {
                const $timeSlotSelectButton = $('#optionTimeslotSelectButton');
                const isTimeSlotSelected = $timeSlotSelectButton.find('span.ax-dropdown__selection').text().length > 0;
                if (!isTimeSlotSelected){
                    valid = false;
                }
            }

            // rental pills
            if (isRentalOptionsHolder && this.initData.hasToCollectData && !bookingValues.skillLevel) {
                $skillLevelPillHolder.addClass('ax-alert--info');
                valid = false;
                this.jumpToSelector('#rentalOptionsHolder');
            } else {
                $skillLevelPillHolder.removeClass('ax-alert--info');
            }

            // rental dropdowns
            if (genderDropdown && !genderDropdown?.val()) {
                valid = false;
                this.jumpToSelector(`.prod_selection__gender-selection.participant-${participant} .ax-dropdown`);
            }

            if (heightDropdown && !heightDropdown.val()) {
                valid = false;
                this.jumpToSelector(`.prod_selection__height-selection.participant-${participant} .ax-dropdown`);
            }

            if (weightDropdown && !weightDropdown?.val()) {
                valid = false;
                this.jumpToSelector(`.prod_selection__weight-selection.participant-${participant} .ax-dropdown`);
            }

            if (shoeSizeDropdown && !shoeSizeDropdown.val()) {
                valid = false;
                this.jumpToSelector(`.prod_selection__shoeSize-selection.participant-${participant} .ax-dropdown`);
            }

        });
        return valid;
    }

    jumpToSelector(selector: string) {
        $([document.documentElement, document.body]).animate({
            scrollTop: ($(selector).offset()?.top ?? 0) - 100
        }, 100);
    }

    addToCart() {
        if (!this.validateInputs()) {
            return;
        }

        this.bookingValuesList.forEach((bookingValues) => {
            const personModule = AxLoad.GetModule<CompPackBookingPersonOptions>("CompPackBookingPersonOptions");
            
            this.participants.forEach((_, i) => {
                const participant = i + 1;
                personModule.setDescriptionAndGenerateHiddenFieldForLessonProperties(`lessonPropsForm-${participant}`);        
            });

            this.axLoading.ShowLoadingIndicatorFixed($('.compPack_bookingOptions_body')?.get(0));

            bookingValues.ticketOrderValues.forEach((ticketEntry) => {
                ticketEntry.timeSlotKeys = ticketEntry?.selectedTimeSlots?.map((timeSlot) => timeSlot.timeSlotKey) || [];
            });
        });

        const data = JSON.stringify(this.bookingValuesList);
        AxessViewer.loadPartialView('/ComplexPackagesBooking/AddComplexPackageToCart', data, (result: any) => {
            const comPackBookingResult: ComPackBookingResult = JSON.parse(result || '{}');

            if (!comPackBookingResult.success) {
                this.axLoading.HideLoadingIndicator($('.compPack_bookingOptions_body')?.get(0));
                Swal.fire({
                    title: this.i18NHelper.GetTranslation(Translations.Error),
                    icon: 'warning',
                    html: comPackBookingResult.errorMsg,
                });
            } else {
                const axPixelTracking = new AxPixelTracking();
                axPixelTracking.AxInit({
                    action: 'addToCart',
                });

                AxLoad.LoadModule('AxGA4Module', {
                    caller: 'Add to Cart',
                    event: 'Add to Cart',
                }).then(() => window.location.href = this.shoppingCartUrl);
            }
        }, {
            dataType: 'html',
            contentType: 'application/json',
        });
    }    
}

class ComPackBookingResult {
    success: boolean;
    errorMsg: string;
}

export interface initData {
    projNr: number;
    packageId: number;
    tariffSheetId: number;
    startSoapDate: string;
    endSoapDate: string;
    shoppingCartUrl: string;
    lessonOrderValues: string;
    participants: number;
    hasToCollectData: boolean;
}
